import { Pipe, PipeTransform } from '@angular/core';
import { IMobileNumber } from '@shared/models/numbers';

@Pipe({
	standalone: true,
	name: 'mobileNumber',
})
export class MobileNumberPipe implements PipeTransform {
	transform(value: IMobileNumber | null): string | null {
		if (!value) {
			return null;
		}
		if (value.e164Number) {
			return value.e164Number;
		}
		if (value.countryCode.startsWith('+') && value.number) {
			// Legacy format
			return `(${value.countryCode}) ${value.number}`;
		}
		return '-';
	}
}
